import Status from "components/base/Status";

const ProductStockDetail = ({ product }) => {
  return (
    <div className="text-sm">
      <div className="-mx-2">
        <table>
          <thead>
            <tr>
              <th>Product</th>
              <th>Origin</th>
              <th className="text-right">QTY</th>
              <th className="text-right">AB</th>
              <th className="text-right">LTD</th>
              <th className="text-right">SS</th>
            </tr>
          </thead>
          <tbody>
            {product.rows.map((row, index) => (
              <tr key={index} className="border-y dark:border-gray-700">
                <td>{row.date}</td>
                <td>
                  <div className="flex items-center space-x-2">
                    <div>{row.origin}</div>
                    <div>
                      {row.type === "PLAN" && (
                        <Status status={row.state} inline />
                      )}
                    </div>
                  </div>
                </td>
                <td className="text-right">
                  {row.odoo_qty} / {row.odoo_ltd_qty} / {row.ss_qty}
                </td>
                <td className="text-right">{row.ab_cumsum}</td>
                <td className="text-right">{row.ltd_cumsum}</td>
                <td className="text-right">{row.ss_cumsum}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductStockDetail;
